import Css from "./style.module.scss";

import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import Constants from "const/Constants";
import DocumentFileTypes from "const/DocumentFileTypes";
import DropArea from "nlib/common/DropArea";
import React, { useCallback } from "react";
import Texts from "utils/Texts";

const FILE_DROP_FORMATS = Object.keys(DocumentFileTypes);

const FILE_DROP_ALLOWED_TYPES = Object.values(DocumentFileTypes)
  .reduce((aggregator, { extensions, mimeType }) => [...aggregator, ...extensions, mimeType], []);

const UploadDocumentTab = ({ onDropFile }) => {
  const { messages } = useSelector(getTextsData);

  const handleFilesDrop = useCallback(([file]) => {
    if (!file) return;
    onDropFile({ file });
  }, [onDropFile]);

  return (
    <div className={Css.uploadDocumentTab}>
      <DropArea
        showAccepted={false}
        className={Css.dropArea}
        extensions={FILE_DROP_FORMATS}
        accept={FILE_DROP_ALLOWED_TYPES}
        hint={Texts.replaceVars(messages.documentUploadPageLimit, { pages: Constants.MAX_DOCUMENT_PAGES })}
        onDrop={handleFilesDrop} />
    </div>
  );
};

export default React.memo(UploadDocumentTab);
